import { render, staticRenderFns } from "./OrderStatusDisplayForm.vue?vue&type=template&id=145369b0"
import script from "./OrderStatusDisplayForm.vue?vue&type=script&lang=js"
export * from "./OrderStatusDisplayForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports